<template>
  <Select
    :placeholder="placeholder"
    clearable
    filterable
    :multiple="multiple"
    :value.sync="value"
    @on-change="change"
  >
    <Option v-for="item in items" :key="item.id" :value="item.id">
      {{ item.name }}
    </Option>
  </Select>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import Model from "@/models/admin/parents";

@Component({
  props: {
    placeholder: {
      type: String,
      default: "请选择家属"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String, Number],
      default: ""
    }
  }
})
export default class ParentSelect extends Vue {
  items = [];

  async created() {
    const {
      data: { items }
    } = await new Model().GET({});
    this.items = items;
  }

  change(value) {
    this.$emit("change", value);
  }
}
</script>
